module.exports = __webpack_public_path__ + "static/codemotion-988c67b7cddbee066846cb88720c2599.png";